import { Card } from 'antd'

function ANTDCard({ ...props }) {
  return <Card {...props} />
}

export default ANTDCard
